import Typography from '@mui/material/Typography';
import React, {useState} from 'react';
import PropTypes from 'prop-types';

//GEOCOMPONENTS
import BottomSheet from '@geomatico/geocomponents/BottomSheet';

//MUI
import Box from '@mui/material/Box';
import Hidden from '@mui/material/Hidden';


//BIKENTA
import AddButton from '../AddButton';
import SectionTitle from '../Layout/SectionTitle';
import VisitsTable from './VisitsTable';
import AddVisitDialog from './AddVisitDialog';

//UTILS
import {visit} from '../proptypes/visit';
import {useTranslation} from 'react-i18next';

const VisitMenu = ({
  disableAddButton=false,
  isCommunityVisit=false,
  isOffline,
  isVisitsShown,
  showAddButton,
  visitList,
  onSelectVisitZone,
  onVisitAdd,
  onVisitDelete,
  onVisitMenuClose
}) => {

  const {t} = useTranslation();

  const [isVisitDialogOpen, setVisitDialogOpen] = useState(false);
  const isTherePendingVisit = visitList.some(visit => visit.status === 'pending');

  const VisitListContent = () => <Box
    display='flex'
    flexDirection='column'
    alignItems='flex-end'
    sx={{gap: 1}}
  >
    <VisitsTable
      visitList={visitList}
      onVisitDelete={onVisitDelete}
      isOffline={isOffline}
      onSelectVisitZone={onSelectVisitZone}
    />
    {
      showAddButton &&
      <AddButton
        disableAddButton={disableAddButton || isOffline || isTherePendingVisit}
        onAddButtonClick={() => setVisitDialogOpen(true)}
      />
    }
    {
      isVisitDialogOpen && <AddVisitDialog
        isAddVisitDialogOpen
        isCommunityVisit={isCommunityVisit}
        onVisitAdd={onVisitAdd} onDialogClose={() => setVisitDialogOpen(false)}
      />
    }
  </Box>;

  return <><Hidden lgDown>{/*DESKTOP*/}
    <SectionTitle title={t('Visitas').toUpperCase()}/>
    <VisitListContent/>
  </Hidden>
  <Hidden lgUp>{/*MOBILE*/}
    {
      (isCommunityVisit && isVisitsShown)//si es de comunidad se muestra en un BottomSheet
        ? <BottomSheet
          closedHeight={120}
          openHeight={'50vh'}
          onToggle={onVisitMenuClose}
          isOpen={isVisitsShown}
        >
          <Box sx={{mb: 10}}>
            <Typography variant='subtitle1' sx={{fontWeight: 'bold', color: 'secondary.main', ml:1}}>
              {t('Visitas').toUpperCase()}
            </Typography>
            <VisitListContent/>
          </Box>
        </BottomSheet>
        : isVisitsShown && <VisitListContent/> //si es de interventionZone se muestra en una tab si está seleccionada
    }
  </Hidden>
  </>;
};

VisitMenu.propTypes = {
  disableAddButton: PropTypes.bool,
  isCommunityVisit: PropTypes.bool,
  isOffline: PropTypes.bool.isRequired,
  isVisitsShown: PropTypes.bool,
  showAddButton: PropTypes.bool,
  visitList: PropTypes.arrayOf(visit),
  onSelectVisitZone: PropTypes.func,
  onVisitAdd: PropTypes.func.isRequired,
  onVisitDelete: PropTypes.func.isRequired,
  onVisitMenuClose: PropTypes.func,
};

export default VisitMenu;